/*
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SessionDetails from "../components/SessionDetails";
import PromptDisplay from "../components/PromptDisplay";
import EntryForm from "../components/EntryForm";
import CollapsibleSection from "../components/CollapsibleSection";
import client from "../api/client";

function EditEntryPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [entryData, setEntryData] = useState(null);

  const [category, setCategory] = useState("");
  const [state, setState] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [intentionTags, setIntentionTags] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [sessionDetails, setSessionDetails] = useState({
    amount: "",
    method: "",
    time_of_day: "",
    session_timing: "",
  });

  useEffect(() => {
    const fetchEntry = async () => {
      try {
        const res = await client.get(`/entries/${id}`);
        const e = res.data;
        setCategory(e.category || "");
        setState(e.state || "");
        setSubcategory(e.subcategory || "");
        setPrompt(e.prompt_text || "");
        setIntentionTags(e.intention_tags || []);  // ADD THIS
        setSessionDetails({
          amount: e.amount || "",
          method: e.method || "",
          time_of_day: e.time_of_day || "",
          session_timing: e.session_timing || "",
        });
        setEntryData(e);
      } catch (err) {
        setError("Unable to load entry.");
      } finally {
        setLoading(false);
      }
    };
    fetchEntry();
  }, [id]);

  const handleSubmit = async (entryData) => {
    setIsSubmitting(true);
    setError("");

    try {
      const payload = {
        title: entryData.title,
        content: entryData.content,
        session_date: entryData.session_date,
        category,
        state,
        subcategory,
        prompt_text: prompt,
        amount: sessionDetails.amount,
        method: sessionDetails.method,
        time_of_day: sessionDetails.time_of_day,
        session_timing: sessionDetails.session_timing,
        strain_name: subcategory,
        mood_before: entryData.mood_before,
        mood_after: entryData.mood_after,
        intention: entryData.intention,
        intention_tags: intentionTags,
        intention_met: entryData.intention_met,
        expected_effects: entryData.expected_effects,
        actual_effects: entryData.actual_effects,
        chakra_checkins: entryData.chakra_checkins,
        archetypal_themes: entryData.archetypal_themes,
        body_sensations: entryData.body_sensations,
        nervous_system_before: entryData.nervous_system_before,
        nervous_system_after: entryData.nervous_system_after,
      };

      await client.put(`/entries/${id}`, payload);
      navigate(`/entry/${id}`);
    } catch (err) {
      setError("Something went wrong saving your entry.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <main className="NewEntryPage">
      <h1>Edit Entry</h1>

      <SessionDetails
        category={category}
        onCategoryChange={setCategory}
        state={state}
        onStateChange={setState}
        subcategory={subcategory}
        onSubcategoryChange={setSubcategory}
        value={sessionDetails}
        onChange={(updated) =>
          setSessionDetails((prev) => ({ ...prev, ...updated }))
        }
      />

      {category && state && subcategory && (
       <CollapsibleSection title="💬 Prompt" defaultOpen={true}>
        <PromptDisplay
         category={category}
         state={state}
         subcategory={subcategory}
         prompt={prompt}
         onPromptChange={setPrompt}
        />
       </CollapsibleSection>
      )}

      <EntryForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        error={error}
        state={state}
        subcategory={subcategory}
        intentionTags={intentionTags}
        onIntentionTagsChange={setIntentionTags}
        initialData={entryData}
      />
    </main>
  );
}

export default EditEntryPage;*/
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import SessionDetails from "../components/SessionDetails";
import PromptDisplay from "../components/PromptDisplay";
import EntryForm from "../components/EntryForm";
import CollapsibleSection from "../components/CollapsibleSection";
import { useSettings } from "../context/SettingsContext";
import client from "../api/client";

function EditEntryPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { settings } = useSettings();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [entryData, setEntryData] = useState(null);

  const [category, setCategory] = useState("");
  const [state, setState] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [intentionTags, setIntentionTags] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [medicineType, setMedicineType] = useState("");
  const [sessionDetails, setSessionDetails] = useState({
    amount: "",
    method: "",
    time_of_day: "",
    session_timing: "",
  });

  useEffect(() => {
    const fetchEntry = async () => {
      try {
        const res = await client.get(`/entries/${id}`);
        const e = res.data;
        setCategory(e.category || "");
        setState(e.state || "");
        setSubcategory(e.subcategory || "");
        setPrompt(e.prompt_text || "");
        setIntentionTags(e.intention_tags || []);
        setMedicineType(e.medicine_type || "cannabis");
        setSessionDetails({
          amount: e.amount || "",
          method: e.method || "",
          time_of_day: e.time_of_day || "",
          session_timing: e.session_timing || "",
        });
        setEntryData(e);
      } catch (err) {
        setError("Unable to load entry.");
      } finally {
        setLoading(false);
      }
    };
    fetchEntry();
  }, [id]);

  const handleSubmit = async (entryData) => {
    setIsSubmitting(true);
    setError("");

    try {
      const payload = {
        title: entryData.title,
        content: entryData.content,
        session_date: entryData.session_date,
        category,
        state,
        subcategory,
        prompt_text: prompt,
        amount: sessionDetails.amount,
        method: sessionDetails.method,
        time_of_day: sessionDetails.time_of_day,
        session_timing: sessionDetails.session_timing,
        strain_name: subcategory,
        mood_before: entryData.mood_before,
        mood_after: entryData.mood_after,
        intention: entryData.intention,
        intention_tags: intentionTags,
        intention_met: entryData.intention_met,
        expected_effects: entryData.expected_effects,
        actual_effects: entryData.actual_effects,
        chakra_checkins: entryData.chakra_checkins,
        archetypal_themes: entryData.archetypal_themes,
        body_sensations: entryData.body_sensations,
        nervous_system_before: entryData.nervous_system_before,
        nervous_system_after: entryData.nervous_system_after,
        medicine_type: medicineType,
      };

      await client.put(`/entries/${id}`, payload);
      navigate(`/entry/${id}`);
    } catch (err) {
      setError("Something went wrong saving your entry.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  const sectionEmoji = medicineType === "mushroom" ? "🌀" : "🌿";

  return (
    <main className="NewEntryPage">
      <h1>Edit Entry</h1>

      <CollapsibleSection title={`${sectionEmoji} Session Details`} defaultOpen={true}>
        <SessionDetails
          category={category}
          onCategoryChange={setCategory}
          state={state}
          onStateChange={setState}
          subcategory={subcategory}
          onSubcategoryChange={setSubcategory}
          value={sessionDetails}
          onChange={(updated) =>
            setSessionDetails((prev) => ({ ...prev, ...updated }))
          }
          medicineType={medicineType}
        />
      </CollapsibleSection>

      {category && state && subcategory && settings.show_prompt && (
        <CollapsibleSection title="💬 Prompt" defaultOpen={true}>
          <PromptDisplay
            category={category}
            state={state}
            subcategory={subcategory}
            prompt={prompt}
            onPromptChange={setPrompt}
            intentionTags={intentionTags}
            medicineType={medicineType}
          />
        </CollapsibleSection>
      )}

      <EntryForm
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        error={error}
        state={state}
        subcategory={subcategory}
        intentionTags={intentionTags}
        onIntentionTagsChange={setIntentionTags}
        initialData={entryData}
        medicineType={medicineType}
      />
    </main>
  );
}

export default EditEntryPage;